<template>
    <div>
        <div class="font-bold text-18 text-im-black-232323 pb-6">{{lbl.iimmpact.confirm_redeem.headline}}</div>
        <div class="text-14 text-im-gray-767676">{{lbl.iimmpact.confirm_redeem.default}}</div>
        <div class="text-14 text-im-gray-767676 pb-6">
            {{lbl.iimmpact.confirm_redeem.use}}
            <span class="text-16 font-bold text-im-black-232323">{{campaign.pointPerUnit}} {{lbl.iimmpact.confirm_redeem.point}}</span>
            {{lbl.iimmpact.confirm_redeem.to_redeem}}
        </div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
//feature
import { useLocale } from "@/feature/LocaleFeature"


export default {
    setup: function() {
        const { lbl } = useLocale()
        return {
            lbl,
        }
    },
    name: 'DefaultConfirmRedeem',
    props: {
        campaign: Object
    },
    data: function () {
        return {
            msg: ''
        };
    },
    created: function () {
        var minutes = this.campaign.minutesValidAfterUsed;
        if (minutes) {
            let days = '';
            let hours = '';
            let result = '';
            if (minutes >= 60) {
                hours = Math.floor(minutes / 60);
                if (hours >= 24) {
                    days = Math.floor(hours / 24);
                }
            }

            if (days > 0) {
                result += days + ' ' + this.lbl.date.days + ' ';
            }

            if (hours / 24 > 0) {
                result += (hours % 24) + ' ' + this.lbl.date.hours + ' ';
            }

            if (minutes / 60 > 0) {
                result += (minutes % 60) + ' ' + this.lbl.date.minutes_short;
            }

            this.msg = Util.stringFormat(this.lbl.iimmpact.confirm_redeem.defualt_have_point, result);
        } else {
            this.msg = this.lbl.iimmpact.confirm_redeem.default;
        }
    }
}
</script>
